"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

if (window.LM_CFG.page.name === 'plsposter') {
  var oldload = window.onload;

  window.onload = function () {
    if (typeof oldOnLoad === 'function') {
      oldOnLoad();
    }

    (function () {
      var decodeUriComponentWithSpace = function decodeUriComponentWithSpace(component) {
        return decodeURIComponent(component.replace(/\+/g, '%20'));
      };

      var getLocationParameters = function getLocationParameters(location, type) {
        if (type !== 'hash' && type !== 'search' && type !== 'both') {
          throw 'getLocationParameters expect argument 2 "type" to be "hash", "search" or "both"';
        }

        var searchString = typeof location.search === 'undefined' ? '' : location.search.substr(1);
        var hashString = typeof location.hash === 'undefined' ? '' : location.hash.substr(1);
        var queries = [];

        if (type === 'search' || type === 'both') {
          queries = queries.concat(searchString.split('&'));
        }

        if (type === 'hash' || type === 'both') {
          queries = queries.concat(hashString.split('&'));
        }

        var params = {};
        var pair = void 0;

        for (var i = 0; i < queries.length; i++) {
          if (queries[i] !== '') {
            pair = queries[i].split('=');

            if (pair.length > 1) {
              params[decodeUriComponentWithSpace(pair[0])] = decodeUriComponentWithSpace(pair[1]);
            }
          }
        }

        return params;
      };

      var setCookie = function setCookie(cookieObj) {
        var defaultPath = '/';
        var hostname = window.location.hostname;
        var domainOnly = hostname.replace(/www\.|stg\./g, '');
        var defaultDomain = domainOnly === hostname ? domainOnly : '.' + domainOnly;

        for (var _len = arguments.length, otherArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          otherArgs[_key - 1] = arguments[_key];
        }

        if (!Array.isArray(cookieObj) && _typeof(cookieObj) === 'object') {
          if (otherArgs.length) {
            var path = otherArgs[0],
                domain = otherArgs[1],
                expires = otherArgs[2];
            path = path || defaultPath;
            domain = domain || defaultDomain;
            Object.keys(cookieObj).forEach(function (cookieName) {
              document.cookie = "".concat(cookieName, "=").concat(cookieObj[cookieName], ";path=").concat(path, ";domain=").concat(domain, ";Expires=Thu, 01 Jan 1970 00:00:01 GMT;");
              document.cookie = "".concat(cookieName, "=").concat(cookieObj[cookieName], ";path=").concat(path, ";domain=").concat(domain, ";") + (expires ? "Expires=".concat(expires, ";") : '');
            });
          } else {
            Object.keys(cookieObj).forEach(function (cookieName) {
              var value = '';
              var path = defaultPath;
              var domain = defaultDomain;
              var expires = '';

              if (_typeof(cookieObj[cookieName]) === 'object') {
                value = cookieObj[cookieName]['value'] || '';
                path = cookieObj[cookieName]['path'] || path;
                domain = cookieObj[cookieName]['domain'] || domain;
                expires = cookieObj[cookieName]['expires'] || '';
              } else {
                value = cookieObj[cookieName];
              }

              document.cookie = "".concat(cookieName, "=").concat(value, ";path=").concat(path, ";domain=").concat(domain, ";Expires=Thu, 01 Jan 1970 00:00:01 GMT;");
              document.cookie = "".concat(cookieName, "=").concat(value, ";path=").concat(path, ";domain=").concat(domain, ";") + (expires ? "Expires=".concat(expires, ";") : '');
            });
          }
        } else if (typeof cookieObj === 'string') {
          if (otherArgs && otherArgs.length) {
            var key = cookieObj;
            var _value = otherArgs[0],
                _path = otherArgs[1],
                _domain = otherArgs[2],
                _expires = otherArgs[3];
            _path = _path || defaultPath;
            _domain = _domain || defaultDomain;
            document.cookie = "".concat(key, "=").concat(_value, ";path=").concat(_path, ";domain=").concat(_domain, ";Expires=Thu, 01 Jan 1970 00:00:01 GMT;");
            document.cookie = "".concat(key, "=").concat(_value, ";path=").concat(_path, ";domain=").concat(_domain, ";") + (_expires ? "Expires=".concat(_expires, ";") : '');
          } else {
            window.debugLog('Error', 'The cookie value must be supplied as the second parameter', value, 'setCookie');
            return false;
          }
        } else {
          window.debugLog('Error', "First parameter must be of type \"object\" or \"string\" - First parameter given is of type: \"".concat(_typeof(cookieObj), "\"."), cookieObj, 'setCookie');
          return false;
        }

        window.debugLog('Info', 'Cookies were set.', document.cookie, 'setCookie');
        return true;
      };

      var urlParams = getLocationParameters(window.location, 'both');
      window.debugLog('URL Params:', urlParams);
      var storeReferralInfo = {
        1: {
          source: "Partner",
          sourceLocation: "Online",
          storeNumber: "CC014",
          storeKey: "1013|2",
          trackingInformation: ""
        },
        2: {
          source: "Partner",
          sourceLocation: "Online",
          storeNumber: "CC052",
          storeKey: "1013|7",
          trackingInformation: ""
        },
        3: {
          source: "Partner",
          sourceLocation: "Online",
          storeNumber: "CC101",
          storeKey: "1013|12",
          trackingInformation: ""
        },
        4: {
          source: "Partner",
          sourceLocation: "Online",
          storeNumber: "CC023",
          storeKey: "1013|3",
          trackingInformation: ""
        },
        5: {
          source: "Partner",
          sourceLocation: "Online",
          storeNumber: "CC033",
          storeKey: "1013|5",
          trackingInformation: ""
        },
        6: {
          source: "Partner",
          sourceLocation: "Online",
          storeNumber: "CC056",
          storeKey: "1013|10",
          trackingInformation: ""
        },
        7: {
          source: "Partner",
          sourceLocation: "Online",
          storeNumber: "CC034",
          storeKey: "1013|6",
          trackingInformation: ""
        },
        8: {
          source: "Partner",
          sourceLocation: "Online",
          storeNumber: "CC062",
          storeKey: "1013|11",
          trackingInformation: ""
        },
        9: {
          source: "Partner",
          sourceLocation: "Online",
          storeNumber: "CC054",
          storeKey: "1013|8",
          trackingInformation: ""
        },
        10: {
          source: "Partner",
          sourceLocation: "Online",
          storeNumber: "CC055",
          storeKey: "1013|9",
          trackingInformation: ""
        },
        11: {
          source: "Partner",
          sourceLocation: "Online",
          storeNumber: "CC025",
          storeKey: "1013|4",
          trackingInformation: ""
        },
        12: {
          source: "Partner",
          sourceLocation: "Online",
          storeNumber: "CC105",
          storeKey: "1013|13",
          trackingInformation: ""
        },
        13: {
          source: "Partner",
          sourceLocation: "Online",
          storeNumber: "CC110",
          storeKey: "1013|15",
          trackingInformation: ""
        },
        14: {
          source: "Partner",
          sourceLocation: "Online",
          storeNumber: "ONLINE",
          storeKey: "1013|16",
          trackingInformation: ""
        },
        default: {
          source: "Partner",
          sourceLocation: "Online",
          storeNumber: "1",
          storeKey: "1013|1",
          trackingInformation: ""
        }
      };
      var referralInformation = storeReferralInfo[urlParams['store']] || storeReferralInfo['default'];
      var source = referralInformation['source'];
      var sourceLocation = referralInformation['sourceLocation'];
      var storeNumber = referralInformation['storeNumber'];
      var storeKey = referralInformation['storeKey'];

      window.debugLog('Ref. Info:', referralInformation);

      setCookie({
        '800LMLandingPage': 'Source=' + source + '&SourceLocation=' + sourceLocation + '&StoreNumber=' + storeNumber + '&StoreKey=' + storeKey
      });
    })();
  };
}